/**
 * Marquee Text.
 * @author Dayne Coulson-Hoffacker
 */
export default class MarqueeText {
  /**
   * Constructs a new Open/Closed instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element

    setTimeout(() => {
      const sentenceLink = this.element.queryAll('span')
      sentenceLink.forEach((element) => {
        const href = element.querySelector('a')
        let colors = ['#fb2918', '#000000', '#e5c79a', '#647c6c', '#eeaea5', '#d10911', '#efb357', '#0166fc', '#ffd400', '#0087a5', '#2a9ff8', '#c3c6c8']
        let active = 0
        setInterval(() => {
          href.style.color = colors[active]
          active++
          if (active == colors.length) active = 0
        }, 500)
      })
    }, 1000)

  }
}



// WEBPACK FOOTER //
// ./components/marquee-text/index.js